import { render, staticRenderFns } from "./SupplierListCreate.vue?vue&type=template&id=e5f06632&"
import script from "./SupplierListCreate.vue?vue&type=script&lang=js&"
export * from "./SupplierListCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports